// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './sidebar';
import Login from './Login';
import CategoryList from './category/CategoryList';
import ProductList from './product/ProductList';
import BTSVideoList from './bts video/BtsVideoList';
import VideoList from './video/Videolist';

function App() {
  const location = useLocation(); // Correct usage of useLocation within Router context

  return (
    <div>
      {/* Show sidebar on all routes except /login */}
      {location.pathname !== '/login' && <Sidebar />}

      <Routes>
        {/* Redirect the root path to the login page */}
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/category-list" element={<CategoryList />} />
        <Route path="/product-list" element={<ProductList />} />
        <Route path="/Video-list" element={<VideoList />} />
        <Route path="/BTS-Video-list" element={<BTSVideoList />} />
      </Routes>
    </div>
  );
}

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWrapper;
